import { useCallback, useRef, useState } from 'react'

import get from 'lodash/get'
import forEach from 'lodash/forEach'
import isEmpty from 'lodash/isEmpty'
import { config } from '../../../components/Init/Init'
import l10n from '../../../components/i18n/I18N'
import { useGetLeaderboardsData } from './useGetLeaderboardsData'
import { useStateValue } from '../../../services/state/StateProvider'
import { getPlayerStatus } from '../../../services/helpers/playerHelper'
import { usePlayerStore } from '../../../services/store'

export const useUpdateTouts = () => {
  const [_, dispatch] = useStateValue()

  const playerStore = usePlayerStore()
  const playerData = playerStore.useAllPlayerStore()

  const { getLeaderboardGames } = useGetLeaderboardsData()
  const [leaderboardGames, setLeaderboardGames] = useState({})
  const isLeaderboardEnabled = get(config.featuresByLocale[l10n.locale], 'leaderboard.enabled', false)
  const isLeaderboardFetched = useRef(false)

  const parseTouts = useCallback(
    ({ leaderboardGames, categories }) => {
      const categoriesCopy = [...categories]
      const arrayOfLeaderboardGameObj = leaderboardGames && Object.entries(leaderboardGames)
      let touts = {}

      forEach(categoriesCopy, category => {
        category.title = l10n.t[`category.${category.id}`]
        // default to both home and chip if unset
        if (!category.displayType) {
          category.displayType = config.categoryDisplayTypes.full
        }

        forEach(category.touts, categoryGame => {
          if (categoryGame[0].asset) {
            // start leader boards parsing
            if (!isEmpty(arrayOfLeaderboardGameObj)) {
              forEach(arrayOfLeaderboardGameObj, ([_, leaderboardGame]) => {
                const gameIds = leaderboardGame.gameIds

                forEach(gameIds, gameId => {
                  if (Number(gameId) === categoryGame[0].asset.id) {
                    categoryGame[0].leaderboardAvailable = true

                    if (categoryGame[0].rewardData) {
                      categoryGame[0].rewardData[leaderboardGame.boardCurrency] = leaderboardGame.rewardCurrency
                    } else {
                      categoryGame[0].rewardData = {}
                      categoryGame[0].rewardData[leaderboardGame.boardCurrency] = leaderboardGame.rewardCurrency
                    }

                    if (leaderboardGame.buyInCost || leaderboardGame.buyInCurrency) {
                      categoryGame[0].leaderboardType = config.leaderboardType.buyIn
                      categoryGame[0].buyInCurrency = leaderboardGame.buyInCurrency
                    } else {
                      categoryGame[0].leaderboardType = config.leaderboardType.free
                    }
                  }
                })
              })
            }
            // end leader boards parsing

            touts[categoryGame[0].asset.id] = categoryGame[0]
          }
        })
      })

      console.log('[Casino] update touts')
      dispatch({
        type: 'addGames',
        casino: {
          touts: touts
        }
      })

      return categoriesCopy
    },
    [dispatch]
  )

  const updateTouts = useCallback(
    async categories => {
      const enableLeaderboardDataFetch =
        isLeaderboardEnabled && !isLeaderboardFetched.current && getPlayerStatus(playerData) === 'logged-in'

      if (enableLeaderboardDataFetch) {
        return await getLeaderboardGames()
          .then(leaderboardGames => {
            setLeaderboardGames(leaderboardGames)
            isLeaderboardFetched.current = true

            return parseTouts({ leaderboardGames, categories })
          })
          .catch(error => {
            console.log('Casino initialization: Failed to fetch available leaderboard by game', error)

            return categories
          })
      } else {
        return parseTouts({ leaderboardGames, categories })
      }
    },
    [getLeaderboardGames, isLeaderboardEnabled, leaderboardGames, parseTouts, playerData]
  )

  return { leaderboardGames, updateTouts }
}
